import React from "react";
import { connect } from 'react-redux'
import { fetchTilbodMultiCustomer } from "../../api/offers/actions";
import { fetchElectronicSigningRecords } from '../../api/signing-records/actions'
import MyPagesSigning from "../../components/my-pages-signing";
import SigningText from "../../components/signing-text";
import { countUnsignedAxDocuments, plural } from "../../utils";
import Alert from 'react-bootstrap/Alert'

class AxSigning extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            activeTab: 'contracts',
        }

        this.setActiveTab = this.setActiveTab.bind(this)
    }

    componentDidMount() {
        if (!window.isIE()) {
            let customer = this.props.customer.split('-').pop(); 
            this.props.dispatch(fetchElectronicSigningRecords(customer));
            this.props.dispatch(fetchTilbodMultiCustomer())

        }
    }

    setActiveTab(tab) {
        this.setState({activeTab: tab})
    }

    render() {
        let customerId = this.props.customer.split('-').pop(); 

        let signingRecords = this.props.signingRecords;
        let customerOffers = this.props.customerOffers;
        let additionalAxDocuments = this.props.additionalAxDocuments; 

        let counter = countUnsignedAxDocuments(signingRecords, customerOffers)

        if (window.isIE()) {
            return (<>
                <div className="page-error">
                    <div className="container justify-content-center text-center">
                        <div className="heading col-12 col-sm-8 mx-auto">
                            <h1>Úpps!</h1>
                            <h2>Við styðjum því miður ekki Internet Explorer. Vinsamlegast notaðu Edge, Chrome, eða Firefox.</h2>
                        </div>
                        <div className="img-container">
                            <img className="img-fluid" src={window.images.iceCream}/>
                        </div>
                        <a className="link mx-auto" href="/">Til baka á forsíðu</a>
                    </div>
                </div> 
            </>)
        }

        {additionalAxDocuments && additionalAxDocuments.error && additionalAxDocuments.errorMessage &&
            <Alert variant="danger" className="col-12 xs-mt-50">
                <Alert.Heading>Villa kom upp í samskiptum</Alert.Heading>
                    <>
                        <hr />
                        <p>
                            {additionalAxDocuments.errorMessage}
                        </p>
                    </>
                )
            </Alert>
        }


        if (signingRecords && signingRecords.data && signingRecords.data.Customer && signingRecords.data.Customer.ElectronicSignatureList && signingRecords.data.Customer.ElectronicSignatureList.ElectronicSignature ) {
            return (
                <>
                    <div className="tab-content w-100" id="pills-tabContent">
                        <div className="heading col-12 col-sm-8 mx-auto mb-5 text-center">
                            { counter > 0 ?
                                <h2 className="light">{ counter } {plural(counter) ? 'skjöl bíða' : 'skjal bíður' } undirritunar</h2>
                                :
                                <h2 className="light">Engin skjöl bíða undirritunar</h2>
                            }
                        </div>

                        <MyPagesSigning customerId={customerId} dispatch={this.props.dispatch} customerOffers={customerOffers} signingRecords={signingRecords} />

                    </div>
                </>
            )
        } else {
            return(
                <div className="tab-content w-100" id="pills-tabContent">
                    <div className="heading col-12 col-sm-8 mx-auto mb-5 text-center">
                        <h2 className="light">Engin skjöl bíða undirritunar</h2>
                    </div>
                    <SigningText />
                </div>
            )
        }
        
    }
}

function mapStateToProps(state) {

    var f = {
        signingRecords: {},
        customerOffers: {},
        additionalAxDocuments: {}
    }
    f.signingRecords = (state.signingRecords === undefined) ? {} : state.signingRecords
    f.customerOffers = (state.customerOffers === undefined) ? {} : state.customerOffers
    f.additionalAxDocuments = (state.additionalAxDocuments === undefined) ? {} : state.additionalAxDocuments
    return f;
}

export default connect(mapStateToProps)(AxSigning);
